export default "__VITE_ASSET__C1uT8bey__"